import { AiFillAppstore } from "react-icons/ai";
import { SiAntdesign } from "react-icons/si";

// Features Data
export const featuresData = [
  {
    id: 2,
    icon: <AiFillAppstore />,
    title: "Web Development",
    des: "Building with HTML, CSS, JS, React & MondgoDB. User-friendly & visually stunning experiences.",
  },

  {
    id: 1,

    title: "Data Analytics",
    des: "Data analysis with Excel, SQL & Tableau. Passionate to learn more  to unlock deeper insights!",
  },

  {
    id: 5,
    icon: <SiAntdesign />,
    title: "Graphic Design",
    des: "I create eye-catching graphics and user interfaces that captivate and connect.Using Photoshop, Canva and Pixel Lab",
  },
];
